module.exports = __webpack_public_path__ + "static/media/File-Import.e03a2b5b.svg";